import React from 'react';
import { EmailProvider } from 'nekst-api';

interface EmailProcessingStatusProps {
  provider?: EmailProvider | null;
}

export default function EmailProcessingStatus({ provider }: EmailProcessingStatusProps) {
  const getProviderName = () => {
    switch (provider) {
      case EmailProvider.GMAIL:
        return 'Gmail';
      default:
        return 'Email';
    }
  };

  return (
    <div>
      <i
        className="fa fa-spinner fa-spin"
        style={{ fontSize: '2rem', marginBottom: '1rem', color: '#007bff' }}
      />
      <h2 style={{ marginBottom: '1rem' }}>Connecting your {getProviderName()} account...</h2>
      <p style={{ color: '#666' }}>
        We're securely linking your {getProviderName()} account for email sending. This should only take a moment.
      </p>
    </div>
  );
}